



// import React, { useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import logo from "../../Images/logo3.png";

// import { FaBars, FaTachometerAlt, FaSignOutAlt } from "react-icons/fa";
// import { GiTeacher } from "react-icons/gi";
// import { MdClass } from "react-icons/md";
// import { BsChatDots } from "react-icons/bs";

// const Slidebar = ({ admin }) => {
//   const navigate = useNavigate();
//   const [hoverItem, setHoverItem] = useState(null);

//   const role = admin?.role || "user";

//   const greeting =
//     role === "admin"
//       ? "Hello Admin!"
//       : role === "teacher"
//       ? "Hello Teacher!"
//       : "Hello User!";

//   const handleLogout = () => {
//     localStorage.removeItem("admin");

//     if (role === "admin") navigate("/admin-login");
//     else navigate("/");

//     window.location.reload();
//   };

//   const navLinkStyle = ({ isActive }, name) => {
//     const isHover = hoverItem === name;

//     return {
//       backgroundColor:
//         isHover || (isActive && !hoverItem) ? "#192B80" : "transparent",
//       color: isHover || (isActive && !hoverItem) ? "#fff" : "#1f3a8a",
//       borderRadius: "6px",
//       padding: "10px 14px",
//       display: "flex",
//       alignItems: "center",
//       width: "100%",
//       textDecoration: "none",
//       fontWeight: "500",
//       transition: "all 0.25s ease",
//     };
//   };

//   return (
//     <>
   
//       <nav
//         className="navbar d-lg-none px-3"
//         style={{ background: "#C9CDCF" }}
//       >
//         <button
//           data-bs-toggle="offcanvas"
//           data-bs-target="#mobileSidebar"
//           style={{
//             color: "#192B80",
//             border: "none",
//             background: "none",
//           }}
//         >
//           <FaBars size={22} />
//         </button>

//         <span
//           className="fw-bold"
//           style={{ color: "#192B80", marginLeft: "auto" }}
//         >
//           {greeting}
//         </span>
//       </nav>

//       <div
//         className="offcanvas offcanvas-start d-lg-none"
//         id="mobileSidebar"
//         style={{ width: "260px", background: "#C9CDCF" }}
//       >
//         <div className="offcanvas-header flex-column text-center">
//           <button
//             className="btn-close ms-auto"
//             data-bs-dismiss="offcanvas"
//           ></button>

//           <img
//             src={logo}
//             alt="logo"
//             className="bg-white rounded-circle"
//             style={{ width: "90px" }}
//           />

//           <h6
//             className="mt-2 fw-bold"
//             style={{ color: "#1f3a8a" }}
//           >
//             Scan n Score
//           </h6>

          
//           <p
//             className="fw-semibold"
//             style={{ color: "#192B80", fontSize: "14px" }}
//           >
//             {greeting}
//           </p>
//         </div>

//         <div className="offcanvas-body d-flex flex-column">
//           <nav className="nav flex-column gap-3">

//             <NavLink
//               to="/admin/dashboard"
//               style={({ isActive }) =>
//                 navLinkStyle({ isActive }, "dashboard")
//               }
//             >
//               <FaTachometerAlt className="me-2" />
//               Dashboard
//             </NavLink>

//             <NavLink
//               to="/admin/classes"
//               style={({ isActive }) =>
//                 navLinkStyle({ isActive }, "classes")
//               }
//             >
//               <MdClass className="me-2" />
//               Classes
//             </NavLink>

//             {role === "admin" && (
//               <NavLink
//                 to="/admin/teacher"
//                 style={({ isActive }) =>
//                   navLinkStyle({ isActive }, "teacher")
//                 }
//               >
//                 <GiTeacher className="me-2" />
//                 Teacher
//               </NavLink>
//             )}

//             <NavLink
//               to="/admin/inquiry"
//               style={({ isActive }) =>
//                 navLinkStyle({ isActive }, "support")
//               }
//             >
//               <BsChatDots className="me-2" />
//               Support
//             </NavLink>

//           </nav>

//           <div
//             className="text-danger mt-auto"
//             style={{
//               cursor: "pointer",
//               padding: "10px 14px",
//               fontSize: "18px",
//             }}
//             data-bs-toggle="modal"
//             data-bs-target="#logoutModal"
//           >
//             <FaSignOutAlt className="me-2" />
//             Logout
//           </div>
//         </div>
//       </div>

    
//       <div
//         className="d-none d-lg-flex flex-column"
//         style={{
//           width: "240px",
//           height: "100vh",
//           background: "#C9CDCF",
//           position: "fixed",
//           left: 0,
//           top: 0,
//         }}
//       >
//         <div className="text-center py-4">
//           <img
//             src={logo}
//             alt="logo"
//             className="bg-white rounded-circle"
//             style={{ width: "90px" }}
//           />

//           <h6
//             className="mt-2 fw-bold"
//             style={{ color: "#1f3a8a" }}
//           >
//             Scan n Score
//           </h6>

     
//         </div>

//         <nav className="nav flex-column p-3 gap-3">

//           <NavLink
//             to="/admin/dashboard"
//             style={({ isActive }) =>
//               navLinkStyle({ isActive }, "dashboard")
//             }
//             onMouseEnter={() => setHoverItem("dashboard")}
//             onMouseLeave={() => setHoverItem(null)}
//           >
//             <FaTachometerAlt className="me-2" />
//             Dashboard
//           </NavLink>

//           <NavLink
//             to="/admin/classes"
//             style={({ isActive }) =>
//               navLinkStyle({ isActive }, "classes")
//             }
//             onMouseEnter={() => setHoverItem("classes")}
//             onMouseLeave={() => setHoverItem(null)}
//           >
//             <MdClass className="me-2" />
//             Classes
//           </NavLink>

//           {role === "admin" && (
//             <NavLink
//               to="/admin/teacher"
//               style={({ isActive }) =>
//                 navLinkStyle({ isActive }, "teacher")
//               }
//               onMouseEnter={() => setHoverItem("teacher")}
//               onMouseLeave={() => setHoverItem(null)}
//             >
//               <GiTeacher className="me-2" />
//               Teacher
//             </NavLink>
//           )}

//           <NavLink
//             to="/admin/inquiry"
//             style={({ isActive }) =>
//               navLinkStyle({ isActive }, "support")
//             }
//             onMouseEnter={() => setHoverItem("support")}
//             onMouseLeave={() => setHoverItem(null)}
//           >
//             <BsChatDots className="me-2" />
//             Support
//           </NavLink>

//         </nav>

//         <div className="mt-auto p-3">
//           <div
//             className="text-danger"
//             style={{
//               cursor: "pointer",
//               padding: "10px 14px",
//               fontSize: "18px",
//             }}
//             data-bs-toggle="modal"
//             data-bs-target="#logoutModal"
//           >
//             <FaSignOutAlt className="me-2" />
//             Logout
//           </div>
//         </div>
//       </div>

  
//       <div className="modal fade" id="logoutModal">
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">

//             <div className="modal-header">
//               <h5 className="modal-title">
//                 Confirm Logout
//               </h5>
//               <button
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//               ></button>
//             </div>

//             <div className="modal-body">
//               Are you sure you want to logout?
//             </div>

//             <div className="modal-footer">
//               <button
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//               >
//                 Cancel
//               </button>

//               <button
//                 className="btn btn-danger"
//                 onClick={handleLogout}
//               >
//                 Logout
//               </button>
//             </div>

//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Slidebar;










import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../Images/logo3.png";

import { FaBars, FaTachometerAlt, FaSignOutAlt, FaTimes } from "react-icons/fa";
import { GiTeacher } from "react-icons/gi";
import { MdClass } from "react-icons/md";
import { BsChatDots } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";
const Slidebar = ({ admin }) => {
  const navigate = useNavigate();
  const [hoverItem, setHoverItem] = useState(null);

  const [showSidebar, setShowSidebar] = useState(false);

  const role = admin?.role || "user";

  const greeting =
    role === "admin"
      ? "Hello Admin!"
      : role === "teacher"
      ? "Hello Teacher!"
      : "Hello User!";

  const openSidebar = () => setShowSidebar(true);
  const closeSidebar = () => setShowSidebar(false);

  const handleLogout = () => {
    localStorage.removeItem("admin");

    if (role === "admin") navigate("/admin-login");
    else navigate("/");

    window.location.reload();
  };

  const navLinkStyle = ({ isActive }, name) => {
    const isHover = hoverItem === name;

    return {
      backgroundColor:
        isHover || (isActive && !hoverItem) ? "#3D4768" : "transparent",
      color: isHover || (isActive && !hoverItem) ? "#fff" : "#b4b8d1",
      borderRadius: "6px",
      padding: "10px 14px",
      display: "flex",
      alignItems: "center",
      width: "100%",
      textDecoration: "none",
      fontWeight: "500",
      transition: "all 0.25s ease",
    };
  };

  return (
    <>
      
      <nav className="navbar d-lg-none px-3" style={{ background: "#272f47" }}>
        <button
          onClick={openSidebar}
          style={{
            color: "#fff",
            border: "none",
            background: "none",
          }}
        >
          <FaBars size={22} />
        </button>

        <span
          className="fw-bold"
          style={{ color: "#fff", marginLeft: "auto" }}
        >
          {greeting}
        </span>
      </nav>

      {showSidebar && (
        <div
          onClick={closeSidebar}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            zIndex: 1040,
          }}
        ></div>
      )}

   
      <div
        style={{
          position: "fixed",
          top: 0,
          left: showSidebar ? "0" : "-260px",
          width: "260px",
          height: "100%",
          background: "#272f47",
          transition: "0.3s ease",
          zIndex: 1050,
        }}
      >
       
        <button
          onClick={closeSidebar}
          style={{
            position: "absolute",
            top: "15px",
            right: "15px",
            background: "none",
            border: "none",
            color: "#fff",
            fontSize: "22px",
            cursor: "pointer",
          }}
        >
          <FaTimes />
        </button>

        <div className="p-3 text-center">
          <img
            src={logo}
            alt="logo"
            className="bg-white rounded-circle mt-3"
            style={{ width: "90px" }}
          />

          <h6 className="mt-2 fw-bold" style={{ color: "#f1f1f5" }}>
            Scan n Score
          </h6>

  
        </div>

        <div className="d-flex flex-column px-3 gap-3 mt-3">
          <NavLink
            to="/admin/dashboard"
            onClick={closeSidebar}
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "dashboard")
            }
          >
            <FaTachometerAlt className="me-2" />
            Dashboard
          </NavLink>

          <NavLink
            to="/admin/classes"
            onClick={closeSidebar}
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "classes")
            }
          >
            <MdClass className="me-2" />
            Classes
          </NavLink>

          {role === "admin" && (
            <NavLink
              to="/admin/teacher"
              onClick={closeSidebar}
              style={({ isActive }) =>
                navLinkStyle({ isActive }, "teacher")
              }
            >
              <GiTeacher className="me-2" />
              Teacher
            </NavLink>
          )}

             {role === "admin" && (
            <NavLink
              to="/admin/result"
              onClick={closeSidebar}
              style={({ isActive }) =>
                navLinkStyle({ isActive }, "result")
              }
            >
              <FaCheckCircle className="me-2" />
              Result
            </NavLink>
          )}

          <NavLink
            to="/admin/inquiry"
            onClick={closeSidebar}
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "support")
            }
          >
            <BsChatDots className="me-2" />
            Support
          </NavLink>

          <div
            className="text-danger mt-auto"
            style={{
              cursor: "pointer",
              padding: "10px 14px",
              fontSize: "18px",
            }}
            onClick={handleLogout}
          >
            <FaSignOutAlt className="me-2" />
            Logout
          </div>
        </div>
      </div>

   
      <div
        className="d-none d-lg-flex flex-column"
        style={{
          width: "240px",
          height: "100vh",
          background: "#272F47",
          position: "fixed",
          left: 0,
          top: 0,
        }}
      >
        <div className="text-center py-4">
          <img
            src={logo}
            alt="logo"
            className="bg-white rounded-circle"
            style={{ width: "90px" }}
          />

          <h6 className="mt-2 fw-bold" style={{ color: "#f1f1f5" }}>
            Scan n Score
          </h6>

       
        </div>

        <nav className="nav flex-column p-3 gap-3">
          <NavLink
            to="/admin/dashboard"
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "dashboard")
            }
            onMouseEnter={() => setHoverItem("dashboard")}
            onMouseLeave={() => setHoverItem(null)}
          >
            <FaTachometerAlt className="me-2" />
            Dashboard
          </NavLink>

          <NavLink
            to="/admin/classes"
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "classes")
            }
            onMouseEnter={() => setHoverItem("classes")}
            onMouseLeave={() => setHoverItem(null)}
          >
            <MdClass className="me-2" />
            Classes
          </NavLink>

          {role === "admin" && (
            <NavLink
              to="/admin/teacher"
              style={({ isActive }) =>
                navLinkStyle({ isActive }, "teacher")
              }
              onMouseEnter={() => setHoverItem("teacher")}
              onMouseLeave={() => setHoverItem(null)}
            >
              <GiTeacher className="me-2" />
              Teacher
            </NavLink>
          )}

              {role === "admin" && (
            <NavLink
              to="/admin/result"
              onClick={closeSidebar}
              style={({ isActive }) =>
                navLinkStyle({ isActive }, "result")
              }
            >
              <FaCheckCircle className="me-2" />
              Result
            </NavLink>
          )}

          <NavLink
            to="/admin/inquiry"
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "support")
            }
            onMouseEnter={() => setHoverItem("support")}
            onMouseLeave={() => setHoverItem(null)}
          >
            <BsChatDots className="me-2" />
            Support
          </NavLink>
        </nav>

        <div className="mt-auto p-3">
          <div
            className="text-danger"
            style={{ cursor: "pointer", padding: "10px 14px" }}
            onClick={handleLogout}
          >
            <FaSignOutAlt className="me-2" />
            Logout
          </div>
        </div>
      </div>
    </>
  );
};

export default Slidebar;